import React, { useEffect, useState } from "react";
import { useGetDatasourceQuery } from "./EditDataSourceSlice";
import {
  useRefetchColumnsDetailsMutation,
  useDeleteDataSourceMutation,
} from "./EditDataSourceSlice";
import useTitle from "../../hooks/useTitle";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { FaXmark } from "react-icons/fa6";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import LoadingIndicator from "../../components/BasicComponents/LoadingIndicator";

export default function EditDataSources() {
  useTitle("Edit-Datasource");
  const {
    data: allDataSources,
    isSuccess: isDataSourcesSuccess,
    isLoading: isDataSourcesLoading,
  } = useGetDatasourceQuery();

  const [
    deleteDataSource,
    {
      data: deletedDataSourceMessage,
      isLoading: isDeleteDataSourceLoading,
      isError: isDeleteDataSourceError,
      error: deleteDataSourceError,
    },
  ] = useDeleteDataSourceMutation();
  const [
    refetchColumnsDetails,
    {
      data: refetechColumnsData,
      isLoading: isRefetchColumnsLoading,
      isError: isRefetchColumnsError,
      isSuccess: isRefetchColumnsSuccess,
      error: refetechColumnsError,
    },
  ] = useRefetchColumnsDetailsMutation();
  const navigate = useNavigate();
  const [dataSourcesArray, setDataSourcesArray] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isDeleteDSModalOpen, setIsDeleteDSModalOpen] = useState(false);

  useEffect(() => {
    if (allDataSources) {
      setDataSourcesArray(allDataSources);
    }
  }, [allDataSources]);

  const handleEditDS = (dataSourceId) => {
    if (dataSourceId) {
      navigate(`/home/dash/edit?dataSourceId=${dataSourceId}`);
    }
  };

  const handleAccessControl = () => {
    // navigate("/home/dash/access");
    navigate(`/home/dash/access?dataSourceId=${dataSourceId}`);
  };


  // const handleAccessControl = () => {
  //   // navigate("/home/dash/access");
  //   navigate(`/home/dash/access?database=${NickName}?id=${dataSourceId}`);
  // };
  const connection =
    selectedRow !== null ? dataSourcesArray[selectedRow] : null;
  // console.log(connection);
  const { NickName, id: dataSourceId } =
    connection !== undefined && connection !== null && connection;
  // console.log(NickName, dataSourceId);

  const handleDeleteDS = (dataSourceId) => {
    if (dataSourceId) {
      // console.log(dataSourceId);
      deleteDataSource(dataSourceId);
      setIsDeleteDSModalOpen(false);
    }
  };

  const handleReSync = (dataSourceId) => {
    if (dataSourceId) {
      refetchColumnsDetails(dataSourceId);
    }
  };
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleDeleteDS(dataSourceId); // Call your function here
    }
  };

  return (
    <>
      {isDataSourcesLoading ? (
        <LoadingIndicator />
      ) : (
        isDataSourcesSuccess && (
          <main className="overflow-auto flex flex-col w-full h-[94vh] min-h-[94vh]">
            <section className="flex items-center justify-between px-[8px] py-[6px] border-y border-gray-400 h-auto">
              <div className="text-left flex font-medium gap-2">
                Data Sources
                {deletedDataSourceMessage ? (
                  <button className="text-green-500">
                    {deletedDataSourceMessage["success"]}
                  </button>
                ) : null}
                {isDeleteDataSourceError ? (
                  <button className="text-red-500">
                    {deleteDataSourceError["data"]["error"]}
                  </button>
                ) : null}
                {refetechColumnsData ? (
                  <button className="text-green-500">
                    {refetechColumnsData["message"]}
                  </button>
                ) : null}
                {isRefetchColumnsError ? (
                  <button className="text-red-500">
                    {refetechColumnsError?.["data"]["error"]}
                  </button>
                ) : null}
              </div>
              <div className="flex items-center justify-center gap-4">
                <button
                  onClick={() => handleAccessControl(dataSourceId)}
                  className={`border border-gray-400 rounded px-3 text-[12px] py-1 ${selectedRow === null
                      ? "bg-gray-100"
                      : "bg-blue-950 text-white shadow-lg"
                    }`}
                  disabled={selectedRow === null}
                >
                  Access control
                </button>
                <button
                  className={`border border-gray-400 rounded px-3 text-[12px] py-1 ${selectedRow === null
                      ? "bg-gray-100"
                      : "bg-gray-950 text-white shadow-lg"
                    }`}
                  disabled={selectedRow === null}
                  onClick={() => handleReSync(dataSourceId)}
                >
                  {isRefetchColumnsLoading ? "ReSyncing..." : "ReSync"}
                </button>
                <button
                  className={`border border-gray-400 rounded px-3 text-[12px] py-1 ${selectedRow === null
                      ? "bg-gray-100"
                      : "bg-pink-600 text-white shadow-lg"
                    }`}
                  disabled={selectedRow === null}
                  onClick={() => setIsDeleteDSModalOpen(true)}
                >
                  Delete
                </button>
                <button
                  className={`border border-gray-400 rounded px-5 text-[12px] py-1 ${selectedRow === null
                      ? "bg-gray-100"
                      : "bg-blue-950 text-white"
                    }`}
                  disabled={selectedRow === null}
                  onClick={() => handleEditDS(dataSourceId)}
                >
                  Edit
                </button>
              </div>
            </section>
            <section className="flex flex-col gap-1 h-[94%] border-gray-300 border pt-2">
              <div className="overflow-y-auto h-full">
                <table className="border-none w-full">
                  <thead className="sticky top-0 bg-white z-10">
                    <tr>
                      <th className="border-b text-left px-2">Name</th>
                      <th className="border-b text-left px-2">Type</th>
                      <th className="border-b text-left px-2">Host</th>
                      <th className="border-b text-left px-2">Owner</th>
                      <th className="border-b text-left px-2">Added On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataSourcesArray.map((row, index) => (
                      <tr
                        key={index}
                        className={`${selectedRow === index
                            ? "bg-blue-950 text-white"
                            : index % 2 === 0
                              ? "bg-gray-100"
                              : ""
                          } cursor-pointer`}
                        onClick={() => setSelectedRow(index)}
                        onDoubleClick={() =>
                          dataSourceId &&
                          navigate(
                            `/home/dash/edit?dataSourceId=${dataSourceId}`
                          )
                        }
                      >
                        <td className="border-b text-left px-2 my-2">
                          {row.NickName}
                        </td>
                        <td className="border-b text-left px-2 my-2">
                          {row.DataBaseType}
                        </td>
                        <td className="border-b text-left px-2 my-2">
                          {row.Host}
                        </td>
                        <td className="border-b text-left px-2 my-2">
                          {row.Owner}
                        </td>
                        <td className="border-b text-left px-2 my-2">
                          {row.AddedOn
                            ? format(
                              new Date(row.AddedOn),
                              "MMMM dd, yyyy h:mm a"
                            )
                            : "Date not available"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          </main>
        )
      )}

      {isDeleteDSModalOpen ? (
        <main
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onKeyDown={handleKeyDown}
        >
          <section className="w-[24rem] h-auto flex flex-col items-start justify-start bg-white rounded gap-1">
            <header className="flex w-full p-2 items-center justify-end rounded-t-lg font-medium">
              <button onClick={() => setIsDeleteDSModalOpen(false)}>
                <FaXmark />
              </button>
            </header>
            <section className="w-full flex flex-col text-center text-lg text-red-600 p-2 font-medium">
              <div className="w-full flex items-center justify-center text-3xl">
                <HiOutlineExclamationCircle className="text-red-600 text-center" />
              </div>
              Are You Sure You Want To Delete {NickName}
            </section>
            <footer className="flex justify-end items-center w-full p-2">
              <button
                className="border py-1 px-2 tracking-wide mr-2 text-gray-700 hover:bg-gray-100 rounded"
                onClick={() => setIsDeleteDSModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className={`border py-1 px-2 tracking-wide bg-red-600 text-white rounded`}
                onClick={() => handleDeleteDS(dataSourceId)}
              >
                {isDeleteDataSourceLoading ? "Deleting..." : "Delete"}
              </button>
            </footer>
          </section>
        </main>
      ) : null}
    </>
  );
}
